import React from 'react'
import { PropTypes } from 'prop-types';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Button } from '@progress/kendo-react-buttons';


const ProfileForm = ({
  onSubmit,
    onChange,
    user,
    registerLocations
}) =>  { 

  return ( 

      <div className="login-container">

        <div className="panel panel-default">

            <div className="panel-heading">
                <span>Please enter your current profile information</span>
            </div>
            <div className="panel-body">
            <form>

                <div className="form-login">

                    <div className="form-group">
                        <label>My Location</label>
                        <DropDownList name="locationId"
                            data={registerLocations}
                            textField="location"
                            dataItemKey="registerLocationId"
                            value={user}
                            onChange={onChange}
                        />                 
                    </div>
                  
                    <div className="form-group">
                        <div className="form-group login-submit">
                            <Button themeColor={'primary'} onClick={onSubmit}>Continue</Button>
                        </div>
                    </div>
    
                </div>

            </form>

            </div>

        </div>

      </div>

    )
}



ProfileForm.ProfileForm = {
  user: PropTypes.object,
  onChange: PropTypes.func
}


export default ProfileForm
